import { P0, S, abs, arc, fillAt, max } from '../../geometry';

export const caterpillar = {
  name: 'Caterpillar',
  colors: ['#2F9E5B', '#E3A008'],
  draw(m, t) {
    let A = 1.5,
      sp = 1.6,
      ant = 0,
      hy = 0,
      st = 1,
      pose = P0();
    if (m === 'happy') {
      A = 5;
      sp = 11;
      ant = 3 * S(t * 12);
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: an inchworm hump keeps rolling from the tail up to the head.
    if (m === 'thinking') {
      A = 9;
      sp = 4.5;
      ant = 3 * S(t * 4.5);
      hy = 1.5 * S(t * 4.5 - 0.6);
    }
    if (m === 'talking') {
      A = 2.5;
      sp = 7;
      ant = 3 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      A = 0;
      hy = -5;
      st = 0.9;
      ant = -5;
      pose.ty = -1;
    }
    if (m === 'paused') {
      A = 0.6;
      sp = 0.7;
      hy = 6;
      st = 1.05;
      ant = 7;
      pose.ty = 2;
    }
    const seg = [
      [50, 66, 10.5],
      [63, 66, 9.5],
      [75, 66, 8.5],
      [86, 66, 7.5],
    ]
      .map(([x, y, r], k) => {
        const h = A * (0.5 + 0.5 * S(t * sp + (k + 1) * 1.1));
        return {
          c: k % 2 ? 'a' : 'b',
          pts: arc(34 + (x - 34) * st, y - h, r, -90, 270, 13),
          n: 18,
        };
      })
      .reverse();
    const hx = 33,
      hc = 48 + hy;
    return {
      strokes: [
        ...seg,
        {
          c: 'b',
          pts: [
            [hx - 7, hc - 14],
            [hx - 11, hc - 23],
            [hx - 16, hc - 25 + ant],
          ],
        },
        {
          c: 'b',
          pts: [
            [hx + 7, hc - 14],
            [hx + 11, hc - 23],
            [hx + 16, hc - 25 + ant],
          ],
        },
        { c: 'a', pts: arc(hx, hc, 17, -90, 270, 17), n: 26 },
      ],
      eyes: { x: hx, y: hc },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1, 2, 3, 6),
};
